import {  useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useViewFieldContext } from '../ViewFieldContext';
import { Loading } from "../../../../../../_metronic/elements/Loading";
import { formatHectares } from "../../../../../shared/numberFormat";
import Land from './Land';

const ListLands = () => {
    const { t } = useTranslation();
    const { field, loadingLands, lands } = useViewFieldContext();
    const totalHa = useMemo(() => {
        if (lands.length < 1) {
            return 0;
        }

        let totalHa = 0;
        lands.forEach(l => totalHa += l.ha);
        return totalHa;
    }, [lands]);

    return (
        <>
        <div className="card shadow-sm field-view-container right-card-data field-view-section-card">
            <div className="card-header collapsible">
                <div data-bs-toggle="collapse" data-bs-target="#kt_list_lands_collapsible" className="card-title cursor-pointer field-view-section-header">
                    <div className="d-flex flex-column">
                        <div className="d-flex align-items-center">
                            <h4 className="field-view-section-title">{t("lands:list.title")}</h4>
                        </div>
                    </div>
                    <span className="text-gray-400 pt-1 fw-semibold fs-7 field-view-section-meta">{t("lands:list.total")} {formatHectares(totalHa)}</span>
                </div>
            </div>
            <div id="kt_list_lands_collapsible" className="collapse show">
                <div className={`card-body ${loadingLands ? 'p-5': 'p-0'}`}>
                    {loadingLands && (
                        <Loading />
                    )}
                    {(!loadingLands && lands.length < 1) && (
                        <>
                            <h5 className="m-0 field-view-empty-state">{t("lands:list.empty_lands")}</h5>
                        </>
                    )}
                    {(!loadingLands && lands.length >= 1) && lands.map(land => {
                        return <Land key={land.land_id} land={land} field={field} />
                    })}
                </div>
            </div>
        </div>
        </>
    );
};

const ListLandsContainer = () => {

    return (
        <>
        <div className="d-flex flex-column flex-row-auto field-view-flex-container displayable">
              <div className="d-flex flex-column-auto">
                  <ListLands />
              </div>
          </div>
        </>
    );
};

export default ListLandsContainer;
